<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section-new">
            <div class="container">
                <el-row>
                    <el-col :span="24">
                        <div class="card card-lift shadow border-0 card-address_page mb-3">
                            <el-breadcrumb separator-class="el-icon-arrow-right" class="vertical-center">
                                <el-breadcrumb-item :to="{ path: '/' }">{{$t('menu.main')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('menu.pro_active')}}</el-breadcrumb-item>
                                <el-breadcrumb-item>{{$t('submenu.xotinqizlar')}}</el-breadcrumb-item>
                            </el-breadcrumb>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </section>
        <section class="section py-1 mb-3">
            <div class="container">
                <card shadow class="card_radius_no" no-body style="z-index: 10;">
                    <div class="px-4">
                        <div class="mt-3 py-3 text-center">
                            <div class="row justify-content-center">
                                <div class="col-lg-11">
                                  <img src="img/ill/Sxema_xotin qizlar_min.jpg" class="page_image">
                                  <div class="h4 text-center"><i class="ni business_briefcase-24 mr-2"></i>{{$t('submenu.xotinqizlar')}}</div>
                                  <div class="text-left" style="display: grid;">
                                    <a href="https://lex.uz/docs/10550" target="_blank" class="xotinqizlar_link">{{$t('xotinqizlar.documents_url')}}</a>
                                    <a href="https://www.lex.uz/docs/4494709" target="_blank" class="xotinqizlar_link">{{$t('xotinqizlar.documents_url2')}}</a>
                                    <a href="https://lex.uz/docs/4494849" target="_blank" class="xotinqizlar_link">{{$t('xotinqizlar.documents_url3')}}</a>
                                    <a href="https://lex.uz/docs/4740345" target="_blank" class="xotinqizlar_link">{{$t('xotinqizlar.documents_url4')}}</a>
                                  </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style>
</style>
